// `monthly` (V3 Monthly plan) is shown from the translated CarePlus/monthlyPlan/label; this is only a fallback.
export const PLAN_TYPE_LABEL: Record<'basic' | 'pro' | 'max' | 'monthly', string> = {
  basic: 'Care+',
  pro: 'Care+ Pro',
  max: 'Care+ Max',
  monthly: 'Monthly',
};

export const NOTIFICATION_VARIANT: Record<CarePlusNotification['type'], 'success' | 'danger' | 'info' | 'warning' | 'neutral'> = {
  dose_adjustment_pending: 'success',
  payment_failed: 'danger',
  paused: 'warning',
  renewal_upcoming: 'info',
  out_of_stock: 'warning',
  video_consultations: 'success',
};

export const statusAccent = (
  status: CarePlusOrderContext['subscriptionStatus'],
  hasPaymentIssue: boolean,
): 'orange' | 'neutral' | 'danger' => {
  if (hasPaymentIssue || status === 'grace_period') return 'danger';
  if (status === 'paused' || status === 'pending') return 'neutral';
  return 'orange';
};
